import DesignTokens from '@tableau/design-tokens';
import { DatasourceCanBaseIconRaw } from '@tableau/icons/DatasourceCanBaseIcon/raw';
import { DatasourceCanCheckIconRaw } from '@tableau/icons/DatasourceCanCheckIcon/raw';
import { DatasourceCanExtractIconRaw } from '@tableau/icons/DatasourceCanExtractIcon/raw';
import { DatasourceTableBaseIconRaw } from '@tableau/icons/DatasourceTableBaseIcon/raw';
import { ReactiveRawIconRegistry } from '@tableau/icons/reactive';

import { applyColor } from '~src/style/ColorService';

import { imgUrl } from '../../commonInfra/utils/ImgUrl';
import {
  cssClass,
} from '../../style';
import { FlowOutputStepRunStatus } from '../models/FlowOutputStepRunInfo';
import { RunFlowTaskStatus } from '../models/RunFlowTaskInfo';
import { ConnectionCategory } from '../utils/FlowDataConnectionUtils';
const cssPrefix = 'FlowIcon';

export const iconClass = cssClass(cssPrefix, 'icon', {
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center center',
});
const getIconToggleExpandDown = () => cssClass(cssPrefix, 'dropdownDown', {
  backgroundImage: imgUrl('expand_open.png')
});
const getIconInputExternalClass = () => cssClass(cssPrefix, 'icon_input_external', {
  backgroundImage: imgUrl('Loom_Flow_Step_Input_DS.svg'),
  borderRadius: 20,
});
const getIconInputFileClass = () => cssClass(cssPrefix, 'icon_input_file', {
  backgroundImage: imgUrl('Loom_Flow_Step_Input_File.svg'),
  borderRadius: 20,
});
const getIconOutputPublishClass = () => cssClass(cssPrefix, 'icon_output_publish', {
  backgroundImage: `var(${ReactiveRawIconRegistry.register(DatasourceCanCheckIconRaw, 20, applyColor(DesignTokens.color.mode_agnostic.default.white, '#FFFFFF'))})`
});
const getIconOutputFileClass = () => cssClass(cssPrefix, 'icon_output_file', {
  backgroundImage: `var(${ReactiveRawIconRegistry.register(DatasourceCanExtractIconRaw, 20, applyColor(DesignTokens.color.mode_agnostic.default.white, '#FFFFFF'))})`
});

const getIconOutputDatabaseClass = () => cssClass(cssPrefix, 'icon_output_database', {
  backgroundImage: `var(${ReactiveRawIconRegistry.register(DatasourceTableBaseIconRaw, 16, applyColor(DesignTokens.color.mode_agnostic.default.white, '#FFFFFF'))})`
});

// White icons for use with dark backgrounds
export function getStepIconClass(type: 'input' | 'output', connectionCategory: ConnectionCategory): string {
  switch (type) {
    case 'input':
      switch (connectionCategory) {
        case 'external':
          return getIconInputExternalClass();
        case 'file':
          return getIconInputFileClass();
        case 'tableau':
          return getIconInputExternalClass();
        case 'tableausite':
          return getIconInputExternalClass();
        default:
          return getIconInputExternalClass();
      }
    case 'output':
      switch (connectionCategory) {
        case 'external':
          return getIconOutputDatabaseClass();
        case 'file':
          return getIconOutputFileClass();
        case 'tableau':
          return getIconOutputPublishClass();
        case 'tableausite':
          return getIconOutputPublishClass();
        default:
          return getIconOutputPublishClass();
      }
    default:
      return '';
  }
}

export function getOutputIconStyle(connectionCategory: ConnectionCategory): React.CSSProperties {
  switch(connectionCategory) {
    case 'external':
      return { backgroundImage: `var(${ReactiveRawIconRegistry.register(DatasourceTableBaseIconRaw, 16, applyColor(DesignTokens.color.font.default.secondary, '#666666'))})` };
    case 'file':
      return { backgroundImage: `var(${ReactiveRawIconRegistry.register(DatasourceCanExtractIconRaw, 18, applyColor(DesignTokens.color.font.default.secondary, '#666666'))})` };
    case 'tableau':
      return { backgroundImage: `var(${ReactiveRawIconRegistry.register(DatasourceCanBaseIconRaw, 18, applyColor(DesignTokens.color.font.default.secondary, '#666666'))})` };
    case 'tableausite':
      return { backgroundImage: `var(${ReactiveRawIconRegistry.register(DatasourceCanBaseIconRaw, 18, applyColor(DesignTokens.color.font.default.secondary, '#666666'))})` };
    default:
      return { backgroundImage: `var(${ReactiveRawIconRegistry.register(DatasourceCanBaseIconRaw, 18, applyColor(DesignTokens.color.font.default.secondary, '#666666'))})` };
  }
}

export function getFlowOutputStepRunIconClass(status: string): string {
  switch (status) {
    case FlowOutputStepRunStatus.pending:
      return 'tb-prep-flow-overview-history-status-pending-icon';
    case FlowOutputStepRunStatus.inProgress:
      return 'tb-prep-flow-overview-history-status-inprogress-icon';
    case FlowOutputStepRunStatus.success:
      return 'tb-prep-flow-overview-history-status-success-icon';
    case FlowOutputStepRunStatus.failed:
      return 'tb-prep-flow-overview-history-status-failed-icon';
    case FlowOutputStepRunStatus.cancelled:
      return 'tb-prep-flow-overview-history-status-cancelled-icon';
    default:
      return 'tb-prep-flow-overview-history-status-failed-icon';
  }
}

export function getRunFlowTaskStatusIconClass(status: string): string {
  switch (status) {
    case RunFlowTaskStatus.Suspended:
      return 'tb-react-dg-hcol tb-icon-server-alert-list-suspended';
    case RunFlowTaskStatus.InProgress:
      return 'tb-prep-flow-overview-history-status-inprogress-icon';
    case RunFlowTaskStatus.Succeeded:
      return 'tb-prep-flow-overview-history-status-success-icon';
    case RunFlowTaskStatus.Failed:
      return 'tb-prep-flow-overview-history-status-failed-icon';
    case RunFlowTaskStatus.Scheduled:
    default:
      return 'tb-prep-flow-overview-history-status-pending-icon';
  }
}
